import { FunctionComponent, useEffect, useState } from 'react';
import { FormLoader, Input, Textarea } from '@teamfabric/copilot-ui';
import { useFormik } from 'formik';
import { Card } from '@mantine/core';
import { Editor } from 'components/Editor/TransformationEditor';

const SchemaDetailsForm: FunctionComponent<{ schemaDetails; events }> = ({
  schemaDetails,
  events,
}) => {
  const [initialValues] = useState({ name: '', description: '', schema: '' });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: values => {
      // TODO: @taha - add validations.
      events?.onSubmit(values);
    },
  });

  useEffect(() => {
    if (schemaDetails.data?.Schema?.name) {
      formik.setValues({
        name: schemaDetails.data.Schema.name,
        description: schemaDetails.data.Schema.description || '',
        schema: schemaDetails.data.Schema.schema,
      });
    }
  }, [schemaDetails.loading]); // eslint-disable-line

  return (
    <>
      {schemaDetails.loading && <FormLoader theme="dark" rowCount={3} />}
      {!schemaDetails.loading && (
        <>
          <form
            id="schemaDetailsForm"
            onSubmit={formik.handleSubmit}
            data-testid="schema-details-form"
          >
            <Card style={{ padding: '36px', margin: '18px 0' }}>
              <Card.Section>
                <h3 style={{ margin: '18px 0' }}>Basic Information</h3>
                <Input
                  width="440px"
                  inputProps={{
                    id: 'name',
                    required: true,
                    value: formik.values.name,
                  }}
                  label="Schema Name"
                  onChange={formik.handleChange}
                />
                <Textarea
                  label="Description"
                  textareaProps={{
                    id: 'description',
                    onChange: formik.handleChange,
                    value: formik.values.description,
                    limit: 50,
                  }}
                  width="440px"
                />
              </Card.Section>
            </Card>
            <div>
              <Editor
                required={true}
                name="transformation"
                onChange={e => formik.setFieldValue('schema', e)}
                placeholder="Schema Definition"
                value={formik.values.schema}
              />
            </div>
          </form>
        </>
      )}
    </>
  );
};

export default SchemaDetailsForm;
